import React, { useState } from 'react';
import { photo } from '../../siteConfig';

// One of our fleet photos as <picture>: webp first, jpg fallback, fixed
// width/height so the layout never jumps, and a shimmer until it has loaded
// (turn that off for photos behind dark overlays, where it would flash).
function Picture({ name, alt, width, height, className = '', imgClassName = '', eager = false, shimmer = true }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <picture className={`block ${loaded || !shimmer ? '' : 'skeleton'} ${className}`}>
      <source type="image/webp" srcSet={photo(name, 'webp')} />
      <img
        src={photo(name, 'jpg')}
        alt={alt}
        width={width}
        height={height}
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
        onLoad={() => setLoaded(true)}
        className={`block h-full w-full object-cover transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'} ${imgClassName}`}
      />
    </picture>
  );
}

export default Picture;
